<template>
	<div class="home-preview">




		<!-- 商品推荐 -->
		<div id="animate_recommendjiyangdian" class="recommend animate__animated">
			<div class="recommend_title_box">
				<span class="recommend_title">寄养点推荐</span>
				<span class="recommend_subhead">{{'jiyangdian'.toUpperCase()}} RECOMMEND</span>
			</div>
			<div class="list list15 index-pv1">
				<div class="list-body-left">
					<template v-if="jiyangdianRecommend.length">
						<template v-for="item,index in jiyangdianRecommend">
							<div v-if="index == 0" @click="toDetail('jiyangdianDetail', item)" class="box1 list-item">
								<img :name="item.id" v-if="preHttp(item.tupian)" :src="item.tupian.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.tupian?item.tupian.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.zhandianmingcheng}}</div>
								</div>
							</div>
						</template>
					</template>
					<template v-if="jiyangdianRecommend.length > 1">
						<template v-for="item,index in jiyangdianRecommend">
							<div v-if="index == 1" @click="toDetail('jiyangdianDetail', item)" class="box2 list-item">
								<img :name="item.id" v-if="preHttp(item.tupian)" :src="item.tupian.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.tupian?item.tupian.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.zhandianmingcheng}}</div>
								</div>
							</div>
						</template>
					</template>
				</div>
				<div class="list-body-center">
					<template v-if="jiyangdianRecommend.length > 2">
						<template v-for="item,index in jiyangdianRecommend">
							<div v-if="index == 2" @click="toDetail('jiyangdianDetail', item)" class="box1 list-item">
								<img :name="item.id" v-if="preHttp(item.tupian)" :src="item.tupian.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.tupian?item.tupian.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.zhandianmingcheng}}</div>
								</div>
							</div>
						</template>
					</template>
					<div class="box2">
						<div class="name">{{jiyangdianRecommend[2].zhandianmingcheng}}</div>
					</div>
					<template v-if="jiyangdianRecommend.length > 3">
						<template v-for="item,index in jiyangdianRecommend">
							<div v-if="index == 3" @click="toDetail('jiyangdianDetail', item)" class="box3 list-item">
								<img :name="item.id" v-if="preHttp(item.tupian)" :src="item.tupian.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.tupian?item.tupian.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.zhandianmingcheng}}</div>
								</div>
							</div>
						</template>
					</template>
				</div>
				<div class="list-body-right">
					<template v-if="jiyangdianRecommend.length > 4">
						<template v-for="item,index in jiyangdianRecommend">
							<div v-if="index == 4" @click="toDetail('jiyangdianDetail', item)" class="box1 list-item">
								<img :name="item.id" v-if="preHttp(item.tupian)" :src="item.tupian.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.tupian?item.tupian.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.zhandianmingcheng}}</div>
								</div>
							</div>
						</template>
					</template>
					<template v-if="jiyangdianRecommend.length > 5">
						<template v-for="item,index in jiyangdianRecommend">
							<div v-if="index == 5" @click="toDetail('jiyangdianDetail', item)" class="box2 list-item">
								<img :name="item.id" v-if="preHttp(item.tupian)" :src="item.tupian.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.tupian?item.tupian.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.zhandianmingcheng}}</div>
								</div>
							</div>
						</template>
					</template>
				</div>
			</div>
			<div class="moreBtn" @click="moreBtn('jiyangdian')">
				<span class="text">查看更多</span>
				<i class="icon iconfont icon-gengduo1"></i>
			</div>
		</div>
		<!-- 商品推荐 -->
		<!-- 商品推荐 -->
		<div id="animate_recommendjiyangfuwu" class="recommend animate__animated">
			<div class="recommend_title_box">
				<span class="recommend_title">寄养服务推荐</span>
				<span class="recommend_subhead">{{'jiyangfuwu'.toUpperCase()}} RECOMMEND</span>
			</div>
			<div class="list list15 index-pv1">
				<div class="list-body-left">
					<template v-if="jiyangfuwuRecommend.length">
						<template v-for="item,index in jiyangfuwuRecommend">
							<div v-if="index == 0" @click="toDetail('jiyangfuwuDetail', item)" class="box1 list-item">
								<img :name="item.id" v-if="preHttp(item.jiyanghuanjing)" :src="item.jiyanghuanjing.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.jiyanghuanjing?item.jiyanghuanjing.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.chongwuzhonglei}}</div>
								</div>
							</div>
						</template>
					</template>
					<template v-if="jiyangfuwuRecommend.length > 1">
						<template v-for="item,index in jiyangfuwuRecommend">
							<div v-if="index == 1" @click="toDetail('jiyangfuwuDetail', item)" class="box2 list-item">
								<img :name="item.id" v-if="preHttp(item.jiyanghuanjing)" :src="item.jiyanghuanjing.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.jiyanghuanjing?item.jiyanghuanjing.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.chongwuzhonglei}}</div>
								</div>
							</div>
						</template>
					</template>
				</div>
				<div class="list-body-center">
					<template v-if="jiyangfuwuRecommend.length > 2">
						<template v-for="item,index in jiyangfuwuRecommend">
							<div v-if="index == 2" @click="toDetail('jiyangfuwuDetail', item)" class="box1 list-item">
								<img :name="item.id" v-if="preHttp(item.jiyanghuanjing)" :src="item.jiyanghuanjing.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.jiyanghuanjing?item.jiyanghuanjing.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.chongwuzhonglei}}</div>
								</div>
							</div>
						</template>
					</template>
					<div class="box2">
						<div class="name">{{jiyangfuwuRecommend[2].chongwuzhonglei}}</div>
						<div class="desc ql-snow ql-editor" v-html="jiyangfuwuRecommend[2].fuwuxiangmu"></div>
					</div>
					<template v-if="jiyangfuwuRecommend.length > 3">
						<template v-for="item,index in jiyangfuwuRecommend">
							<div v-if="index == 3" @click="toDetail('jiyangfuwuDetail', item)" class="box3 list-item">
								<img :name="item.id" v-if="preHttp(item.jiyanghuanjing)" :src="item.jiyanghuanjing.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.jiyanghuanjing?item.jiyanghuanjing.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.chongwuzhonglei}}</div>
								</div>
							</div>
						</template>
					</template>
				</div>
				<div class="list-body-right">
					<template v-if="jiyangfuwuRecommend.length > 4">
						<template v-for="item,index in jiyangfuwuRecommend">
							<div v-if="index == 4" @click="toDetail('jiyangfuwuDetail', item)" class="box1 list-item">
								<img :name="item.id" v-if="preHttp(item.jiyanghuanjing)" :src="item.jiyanghuanjing.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.jiyanghuanjing?item.jiyanghuanjing.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.chongwuzhonglei}}</div>
								</div>
							</div>
						</template>
					</template>
					<template v-if="jiyangfuwuRecommend.length > 5">
						<template v-for="item,index in jiyangfuwuRecommend">
							<div v-if="index == 5" @click="toDetail('jiyangfuwuDetail', item)" class="box2 list-item">
								<img :name="item.id" v-if="preHttp(item.jiyanghuanjing)" :src="item.jiyanghuanjing.split(',')[0]" alt="" />
								<img :name="item.id" v-else :src="baseUrl + (item.jiyanghuanjing?item.jiyanghuanjing.split(',')[0]:'')" alt="" />
								<div class="infoBox">
									<div class="name">{{item.chongwuzhonglei}}</div>
								</div>
							</div>
						</template>
					</template>
				</div>
			</div>
			<div class="moreBtn" @click="moreBtn('jiyangfuwu')">
				<span class="text">查看更多</span>
				<i class="icon iconfont icon-gengduo1"></i>
			</div>
		</div>
		<!-- 商品推荐 -->
		<!-- 特价商品 -->
		<div id="animate_listjiyangfuwu" class="lists animate__animated">
			<div class="list_title_box">
				<span class="list_title">寄养服务展示</span>
				<span class="list_subhead">{{'jiyangfuwu'.toUpperCase()}} SHOW</span>
			</div>
			<div v-if="jiyangfuwuList.length" class="list list12 index-pv1 list12jiyangfuwu">
				<div class="list-body">
					<div class="item list-item animation-box" v-for="item,index in jiyangfuwuList" :key="index" @click="toDetail('jiyangfuwuDetail', item)">
						<img :name="item.id" v-if="preHttp(item.jiyanghuanjing)" :src="item.jiyanghuanjing.split(',')[0]" alt="" />
						<img :name="item.id" v-else :src="baseUrl + (item.jiyanghuanjing?item.jiyanghuanjing.split(',')[0]:'')" alt="" />
						<div class="name">{{item.chongwuzhonglei}}</div>
					</div>
				</div>
			</div>
			<div class="moreBtn" @click="moreBtn('jiyangfuwu')">
				<span class="text">查看更多</span>
				<i class="icon iconfont icon-gengduo1"></i>
			</div>
	

		</div>
		<!-- 特价商品 -->
		<!-- 特价商品 -->
		<div id="animate_listchongwuyanghu" class="lists animate__animated">
			<div class="list_title_box">
				<span class="list_title">宠物养护展示</span>
				<span class="list_subhead">{{'chongwuyanghu'.toUpperCase()}} SHOW</span>
			</div>
			<div v-if="chongwuyanghuList.length" class="list list12 index-pv1 list12chongwuyanghu">
				<div class="list-body">
					<div class="item list-item animation-box" v-for="item,index in chongwuyanghuList" :key="index" @click="toDetail('chongwuyanghuDetail', item)">
						<img :name="item.id" v-if="preHttp(item.yanghutupian)" :src="item.yanghutupian.split(',')[0]" alt="" />
						<img :name="item.id" v-else :src="baseUrl + (item.yanghutupian?item.yanghutupian.split(',')[0]:'')" alt="" />
						<div class="name">{{item.chongwumingcheng}}</div>
					</div>
				</div>
			</div>
			<div class="moreBtn" @click="moreBtn('chongwuyanghu')">
				<span class="text">查看更多</span>
				<i class="icon iconfont icon-gengduo1"></i>
			</div>
	

		</div>
		<!-- 特价商品 -->
		<!-- 特价商品 -->
		<div id="animate_listjifenshangpin" class="lists animate__animated">
			<div class="list_title_box">
				<span class="list_title">积分商品展示</span>
				<span class="list_subhead">{{'jifenshangpin'.toUpperCase()}} SHOW</span>
			</div>
			<div v-if="jifenshangpinList.length" class="list list12 index-pv1 list12jifenshangpin">
				<div class="list-body">
					<div class="item list-item animation-box" v-for="item,index in jifenshangpinList" :key="index" @click="toDetail('jifenshangpinDetail', item)">
						<img :name="item.id" v-if="preHttp(item.fengmian)" :src="item.fengmian.split(',')[0]" alt="" />
						<img :name="item.id" v-else :src="baseUrl + (item.fengmian?item.fengmian.split(',')[0]:'')" alt="" />
						<div class="name">商品名称:{{item.shangpinmingcheng}}</div>
						<div class="name">规格:{{item.guige}}</div>
					</div>
				</div>
			</div>
			<div class="moreBtn" @click="moreBtn('jifenshangpin')">
				<span class="text">查看更多</span>
				<i class="icon iconfont icon-gengduo1"></i>
			</div>
	

		</div>
		<!-- 特价商品 -->
	</div>
</template>

<script>
import 'animate.css'
import Swiper from "swiper";

	export default {
		//数据集合
		data() {
			return {
				baseUrl: '',
				newsList: [],
				jiyangdianRecommend: [],
				jiyangfuwuRecommend: [],

				jiyangfuwuList: [],
				chongwuyanghuList: [],
				jifenshangpinList: [],




			}
		},
		created() {
			this.baseUrl = this.$config.baseUrl;
			this.getList();
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
			setTimeout(()=>{
				this.handleScroll()
			},100)
			
			this.swiperChanges()
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		//方法集合
		methods: {
			swiperChanges() {
				setTimeout(()=>{
				},750)
			},
			newsIndexClick15(index) {
				this.newsIndex15 = index
				this.getNewsList()
			},
			getNewsCategory() {
				this.$http.get('newstype/list', {}).then(res => {
					if (res.data.code == 0) {
						this.newsCategoryList15 = res.data.data
					}
				});
			},

			listIndexClick12(index, name) {
				this['listIndex12' + name] = index
				this.getList()
				
				document.querySelectorAll('.lists .list12' + name + ' .list .item').forEach(el => {
				  el.classList.remove("active")
				})
				setTimeout(() => {
				  document.querySelectorAll('.lists .list12' + name + ' .list .item').forEach(el => {
					el.classList.add("active")
				  })
				}, 1);
			},

			handleScroll() {
				let arr = [
					{id:'about',css:'animate__bounce'},
					{id:'system',css:'animate__bounce'},
					{id:'animate_recommendjiyangdian',css:'animate__bounce'},
					{id:'animate_recommendjiyangfuwu',css:'animate__bounce'},
					{id:'animate_listjiyangfuwu',css:'animate__bounce'},
					{id:'animate_listchongwuyanghu',css:'animate__bounce'},
					{id:'animate_listjifenshangpin',css:'animate__bounce'},
				]
			
				for (let i in arr) {
					let doc = document.getElementById(arr[i].id)
					if (doc) {
						let top = doc.offsetTop
						let win_top = window.innerHeight + window.pageYOffset
						// console.log(top,win_top)
						if (win_top > top && doc.classList.value.indexOf(arr[i].css) < 0) {
							// console.log(doc)
							doc.classList.add(arr[i].css)
						}
					}
				}
			},
			preHttp(str) {
				return str && str.substr(0,4)=='http';
			},
			getList() {
				let autoSortUrl = "";
				let data = {}
				autoSortUrl = "jiyangdian/autoSort";
				if(localStorage.getItem('frontToken')) {
					autoSortUrl = "jiyangdian/autoSort2";
				}
				data = {
					page: 1,
					limit: 6,
				}
				this.$http.get(autoSortUrl, {params: data}).then(res => {
					if (res.data.code == 0) {
						this.jiyangdianRecommend = res.data.data.list;
					}
				});
				autoSortUrl = "jiyangfuwu/autoSort";
				if(localStorage.getItem('frontToken')) {
					autoSortUrl = "jiyangfuwu/autoSort2";
				}
				data = {
					page: 1,
					limit: 6,
				}
				data['sfsh'] = '是'
				this.$http.get(autoSortUrl, {params: data}).then(res => {
					if (res.data.code == 0) {
						this.jiyangfuwuRecommend = res.data.data.list;
					}
				});
			
				data = {
					page: 1,
					limit: 8,
				}
				data['sfsh']= '是'

				this.$http.get('jiyangfuwu/list', {params: data}).then(res => {
					if (res.data.code == 0) {
						this.jiyangfuwuList = res.data.data.list;
					}
				});
				data = {
					page: 1,
					limit: 8,
				}

				this.$http.get('chongwuyanghu/list', {params: data}).then(res => {
					if (res.data.code == 0) {
						this.chongwuyanghuList = res.data.data.list;
					}
				});
				data = {
					page: 1,
					limit: 8,
				}

				this.$http.get('jifenshangpin/list', {params: data}).then(res => {
					if (res.data.code == 0) {
						this.jifenshangpinList = res.data.data.list;
					}
				});
			},
			toDetail(path, item) {
				this.$router.push({path: '/index/' + path, query: {id: item.id}});
			},
			moreBtn(path) {
				this.$router.push({path: '/index/' + path});
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.home-preview {
		margin: 0;
		flex-direction: column;
		display: flex;
		width: 100%;
		.recommend {
			padding: 40px 0;
			margin: 0;
			background: url(http://codegen.caihongy.cn/20241212/bb4df976a63843a48b9af8b142771f6b.webp) no-repeat center / cover;
			position: relative;
			order: 3;
			.recommend_title_box {
				padding: 0 0 0 180px;
				margin: 10px auto;
				background: url(http://codegen.caihongy.cn/20241210/a35f0a1a1ae54a6599c8a9c34f6344e8.webp) no-repeat center / 100% 100%;
				width: 1300px;
				line-height: 100px;
				text-align: left;
				height: 100px;
				.recommend_title {
					color: #000000;
					font-weight: 700;
					font-size: 36px;
				}
				.recommend_subhead {
					margin: 0 0 10px;
					color: #999;
					display: none;
					width: 100%;
					font-size: 20px;
					line-height: 1.5;
					text-align: center;
				}
			}
			.index-pv1 .animation-box {
				transform: rotate(0deg) scale(1) skew(0deg, 0deg) translate3d(0px, 0px, 0px);
				z-index: initial;
			}
			
			.index-pv1 .animation-box:hover {
				transform: rotate(0deg) scale(1) skew(0deg, 0deg) translate3d(0px, 10px, 0px);
				-webkit-perspective: 1000px;
				perspective: 1000px;
				transition: 0.3s;
				z-index: 1;
			}
			
			.index-pv1 .animation-box img {
				transform: rotate(0deg) scale(1) skew(0deg, 0deg) translate3d(0px, 0px, 0px);
			}
			
			.index-pv1 .animation-box img:hover {
				transform: rotate(0deg) scale(1.1) skew(0deg, 0deg) translate3d(0px, 0px, 0px);
				-webkit-perspective: 1000px;
				perspective: 1000px;
				transition: 0.3s;
			}
			.list15 {
				padding: 0;
				margin: 0 auto;
				display: flex;
				width: 1300px;
				justify-content: center;
				align-items: center;
				height: auto;
				.list-body-left {
					width: 32%;
					height: auto;
					.box1 {
						border: 2px solid transparent;
						border-radius: 10px;
						margin: 10px 0;
						overflow: hidden;
						background: none;
						width: 100%;
						position: relative;
						transition: all .3s;
						height: auto;
						img {
							border-radius: 10px;
							object-fit: cover;
							display: block;
							width: 100% ;
							transition: all .3s;
							height: 180px;
						}
						.infoBox {
							flex-direction: column;
							left: 0;
							background: rgba(0,0,0,.3);
							bottom: 0;
							display: flex;
							width: 100%;
							justify-content: center;
							align-items: center;
							position: absolute;
							opacity: 0;
							transition: all .3s;
							height: 100%;
							.name {
								color: #fff;
								font-size: 16px;
								line-height: 24px;
							}
							.price {
								padding: 10px;
								color: #f00;
								font-size: 13px;
								line-height: 1.5;
							}
						}
					}
					.box1:hover {
						border: 1px solid #ff0;
						img {
							transform: scale(1.2);
						}
						.infoBox {
							opacity: 1;
						}
					}
					.box2 {
						border-radius: 10px;
						margin: 10px 0;
						overflow: hidden;
						background: none;
						width: 100%;
						position: relative;
						transition: all .3s;
						height: auto;
						img {
							border-radius: 10px;
							object-fit: cover;
							display: block;
							width: 100% ;
							transition: all .3s;
							height: 180px;
						}
						.infoBox {
							flex-direction: column;
							left: 0;
							background: rgba(0,0,0,.3);
							bottom: 0;
							display: flex;
							width: 100%;
							justify-content: center;
							align-items: center;
							position: absolute;
							opacity: 0;
							transition: all .3s;
							height: 100%;
							.name {
								color: #fff;
								font-size: 16px;
								line-height: 24px;
							}
							.price {
								padding: 10px;
								color: #f00;
								font-size: 13px;
								line-height: 1.5;
							}
						}
					}
					.box2:hover {
						border: 1px solid #ff0;
						img {
							transform: scale(1.2);
						}
						.infoBox {
							opacity: 1;
						}
					}
				}
				.list-body-center {
					margin: 0 2%;
					width: 32%;
					height: auto;
					.box1 {
						border: 1px solid transparent;
						border-radius: 10px;
						margin: 10px 0;
						overflow: hidden;
						background: #fff;
						width: 100%;
						position: relative;
						transition: all .3s;
						height: auto;
						img {
							object-fit: cover;
							display: block;
							width: 100% ;
							transition: all .3s;
							height: 180px;
						}
						.infoBox {
							flex-direction: column;
							left: 0;
							background: rgba(0,0,0,.3);
							bottom: 0;
							display: flex;
							width: 100%;
							justify-content: center;
							align-items: center;
							position: absolute;
							opacity: 0;
							transition: all .3s;
							height: 100%;
							.name {
								color: #fff;
								font-size: 16px;
								line-height: 24px;
							}
							.price {
								padding: 10px;
								color: #f00;
								font-size: 13px;
								line-height: 1.5;
							}
						}
					}
					.box1:hover {
						border: 1px solid #ff0;
						img {
							transform: scale(1.2);
						}
						.infoBox {
							opacity: 1;
						}
					}
					.box2 {
						border: 5px solid #423DD2;
						border-radius: 50%;
						padding: 30px;
						margin: 10px 0;
						background-clip: content-box;
						flex-direction: column;
						background: #423DD2;
						display: flex;
						width: 100%;
						justify-content: center;
						align-items: center;
						height: 432px;
						.name {
							color: #fff;
							font-size: 16px;
							line-height: 24px;
						}
						.price {
							padding: 10px;
							color: red;
							font-size: 24px;
							line-height: 1.5;
						}
						.desc {
							color: #fff;
							display: none;
							font-size: 16px;
							line-height: 1.5;
						}
					}
					.box3 {
						border: 1px solid transparent;
						border-radius: 10px;
						margin: 10px 0;
						overflow: hidden;
						background: #fff;
						width: 100%;
						position: relative;
						transition: all .3s;
						height: auto;
						img {
							object-fit: cover;
							display: block;
							width: 100% ;
							transition: all .3s;
							height: 180px;
						}
						.infoBox {
							flex-direction: column;
							left: 0;
							background: rgba(0,0,0,.3);
							bottom: 0;
							display: flex;
							width: 100%;
							justify-content: center;
							align-items: center;
							position: absolute;
							opacity: 0;
							transition: all .3s;
							height: 100%;
							.name {
								color: #fff;
								font-size: 16px;
								line-height: 24px;
							}
							.price {
								padding: 10px;
								color: #f00;
								font-size: 13px;
								line-height: 1.5;
							}
						}
					}
					.box3:hover {
						border: 1px solid #ff0;
						img {
							transform: scale(1.2);
						}
						.infoBox {
							opacity: 1;
						}
					}
				}
				.list-body-right {
					width: 32%;
					height: auto;
					.box1 {
						border: 1px solid transparent;
						border-radius: 10px;
						margin: 10px 0;
						overflow: hidden;
						background: #fff;
						width: 100%;
						position: relative;
						transition: all .3s;
						height: auto;
						img {
							object-fit: cover;
							display: block;
							width: 100% ;
							transition: all .3s;
							height: 180px;
						}
						.infoBox {
							flex-direction: column;
							left: 0;
							background: rgba(0,0,0,.3);
							bottom: 0;
							display: flex;
							width: 100%;
							justify-content: center;
							align-items: center;
							position: absolute;
							opacity: 0;
							transition: all .3s;
							height: 100%;
							.name {
								color: #fff;
								font-size: 16px;
								line-height: 24px;
							}
							.price {
								padding: 10px;
								color: #f00;
								font-size: 13px;
								line-height: 1.5;
							}
						}
					}
					.box1:hover {
						border: 1px solid #ff0;
						img {
							transform: scale(1.2);
						}
						.infoBox {
							opacity: 1;
						}
					}
					.box2 {
						border: 1px solid transparent;
						border-radius: 10px;
						margin: 10px 0;
						overflow: hidden;
						background: #fff;
						width: 100%;
						position: relative;
						transition: all .3s;
						height: auto;
						img {
							object-fit: cover;
							display: block;
							width: 100% ;
							transition: all .3s;
							height: 180px;
						}
						.infoBox {
							flex-direction: column;
							left: 0;
							background: rgba(0,0,0,.3);
							bottom: 0;
							display: flex;
							width: 100%;
							justify-content: center;
							align-items: center;
							position: absolute;
							opacity: 0;
							transition: all .3s;
							height: 100%;
							.name {
								color: #fff;
								font-size: 16px;
								line-height: 24px;
							}
							.price {
								padding: 10px;
								color: #f00;
								font-size: 13px;
								line-height: 1.5;
							}
						}
					}
					.box2:hover {
						border: 1px solid #ff0;
						img {
							transform: scale(1.2);
						}
						.infoBox {
							opacity: 1;
						}
					}
				}
			}
			.moreBtn {
				border: 0;
				cursor: pointer;
				padding: 0 0 0 40px;
				margin: 10px auto;
				display: block;
				line-height: 60px;
				right: calc(50% - 620px);
				top: 60px;
				background: url(http://codegen.caihongy.cn/20241210/54e0395d6e624dbcb8ec2ba83b2ff14b.webp);
				width: 190px;
				position: absolute;
				text-align: left;
				height: 60px;
				.text {
					color: #FFFFFF;
					font-size: 14px;
				}
				.icon {
					color: #f5f5f5;
					font-size: 12px;
				}
			}
		}
		.lists {
			padding: 40px 0;
			margin: 0;
			background: url(http://codegen.caihongy.cn/20241212/431a3acb917e4f81824c2f0bdf8b3791.webp) no-repeat center / cover;
			width: 100%;
			position: relative;
			order: 5;
			.list_title_box {
				padding: 0 0 0 180px;
				margin: 10px auto;
				background: url(http://codegen.caihongy.cn/20241210/a35f0a1a1ae54a6599c8a9c34f6344e8.webp) no-repeat center / 100% 100%;
				width: 1300px;
				line-height: 100px;
				text-align: left;
				height: 100px;
				.list_title {
					color: #000000;
					font-weight: 700;
					font-size: 36px;
				}
				.list_subhead {
					margin: 0 0 10px;
					color: #999;
					width: 100%;
					font-size: 20px;
					line-height: 1.5;
					text-align: center;
				}
			}
			.index-pv1 .animation-box {
				transform: rotate(0deg) scale(1) skew(0deg, 0deg) translate3d(0px, 0px, 0px);
				z-index: initial;
			}
			
			.index-pv1 .animation-box:hover {
				transform: rotate(0deg) scale(1) skew(0deg, 0deg) translate3d(0px, 10px, 0px);
				-webkit-perspective: 1000px;
				perspective: 1000px;
				transition: 0.3s;
				z-index: 1;
			}
			
			.index-pv1 .animation-box img {
				transform: rotate(0deg) scale(1) skew(0deg, 0deg) translate3d(0px, 0px, 0px);
			}
			
			.index-pv1 .animation-box img:hover {
				transform: rotate(0deg) scale(1.1) skew(0deg, 0deg) translate3d(0px, 0px, 0px);
				-webkit-perspective: 1000px;
				perspective: 1000px;
				transition: 0.3s;
			}
			.list12 {
				padding: 10px;
				margin: 0 auto;
				background: none;
				width: 1300px;
				height: auto;
				.tab_view {
					margin: 20px 0 0;
					display: flex;
					width: 100%;
					justify-content: center;
					height: auto;
					.tab {
						cursor: pointer;
						padding: 0 20px 10px ;
						margin: 0 10px;
						color: #8D8D8D;
						display: flex;
						width: auto;
						font-size: 18px;
						border-color: transparent;
						border-width: 0 0 1px 0;
						line-height: 44px;
						align-items: center;
						border-style: solid;
						img {
							border-radius: 5px;
							margin: 0 5px 0 0;
							object-fit: cover;
							display: block;
							width: 50px;
							height: 50px;
						}
						.text {
							color: inherit;
							font-size: 18px;
						}
					}
					.tab:hover {
						color: #423DD2;
						border-color: #423DD2;
					}
					.tab.active {
						color: #423DD2;
						border-color: #423DD2;
					}
					.more_btn {
						cursor: pointer;
						padding: 5px 10px;
						margin: 0 10px;
						color: #666;
						background: #fff;
						display: none;
						line-height: 44px;
						align-items: center;
						.text {
							color: inherit;
							font-size: 14px;
						}
						.icon {
							margin: 0 0 0 2px;
							color: inherit;
							font-size: 14px;
						}
					}
					.more_btn:hover {
						color: red;
					}
					.tab.active {
						animation-name: mymove;
					
						&:nth-of-type(1) {
							animation-duration: 1s;
						}
						&:nth-of-type(2) {
							animation-duration: 1.2s;
						}
						&:nth-of-type(3) {
							animation-duration: 1.4s;
						}
						&:nth-of-type(4) {
							animation-duration: 1.6s;
						}
						&:nth-of-type(5) {
							animation-duration: 1.8s;
						}
						&:nth-of-type(6) {
							animation-duration: 2s;
						}
					}
					
					@keyframes mymove {
						from {top: 320px;}
						to {top: 0;}
					}
				}
				.list-body {
					margin: 40px 0 0;
					overflow: hidden;
					flex: 1;
					background: none;
					display: flex;
					justify-content: space-between;
					flex-wrap: wrap;
					height: auto;
					.list-item {
						border-radius: 10px;
						padding: 15px;
						background: linear-gradient( 180deg, #C2C0FF 0%, rgba(216,216,216,0) 100%);
						width: 300px;
						position: relative;
						height: auto;
						img {
							border: 5px solid #F1F1F1;
							border-radius: 10px;
							object-fit: cover;
							display: block;
							width: 100%;
							height: 260px;
						}
						.name {
							padding: 0 10px;
							margin: 10px 0 0;
							overflow: hidden;
							color: #333;
							white-space: nowrap;
							font-weight: 600;
							font-size: 16px;
							line-height: 24px;
							text-overflow: ellipsis;
							text-align: center;
						}
						.price {
							padding: 10px;
							color: #D10000;
							font-weight: 600;
							font-size: 16px;
							line-height: 24px;
							text-align: center;
						}
					}
					.list-item.active {
						animation-name: mymove;
					
						&:nth-of-type(1) {
							animation-duration: 1s;
						}
						&:nth-of-type(2) {
							animation-duration: 1.2s;
						}
						&:nth-of-type(3) {
							animation-duration: 1.4s;
						}
						&:nth-of-type(4) {
							animation-duration: 1.6s;
						}
						&:nth-of-type(5) {
							animation-duration: 1.8s;
						}
						&:nth-of-type(6) {
							animation-duration: 2s;
						}
					}
					
					@keyframes mymove {
						from {top: 320px;}
						to {top: 0;}
					}
				}
			}
			.moreBtn {
				border: 0;
				cursor: pointer;
				padding: 0 0 0 40px;
				margin: 10px auto;
				display: block;
				line-height: 60px;
				right: calc(50% - 620px);
				top: 60px;
				background: url(http://codegen.caihongy.cn/20241210/54e0395d6e624dbcb8ec2ba83b2ff14b.webp);
				width: 190px;
				position: absolute;
				text-align: left;
				height: 60px;
				.text {
					color: #FFFFFF;
					font-size: 14px;
				}
				.icon {
					color: #f5f5f5;
					font-size: 12px;
				}
			}
		}
	}
</style>
